import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthStateType, UserType } from '@src/types/main';
import {
  deleteSessionToken,
  deleteToken,
  setSessionToken,
  setToken,
} from '@src/utils/auth';

type CredentialsType = {
  user: UserType;
  token: string;
  rememberMe: boolean;
};

const initialState: AuthStateType = {
  user: null,
  token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<CredentialsType>) => {
      const { user, token, rememberMe } = action.payload;

      state.user = user;
      state.token = token;

      localStorage.setItem('rememberMe', JSON.stringify(rememberMe));
      setSessionToken(token);

      if (rememberMe) {
        setToken(token);
      }
    },
    logOut: (state) => {
      state.user = null;
      state.token = null;

      deleteToken();
      deleteSessionToken();
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;
